exports.install = function (Vue, options) {
    Vue.prototype.userImgDefalt = function (e) {
        if (e.type === "error") {
            e.target.src = Vue.prototype.$store.state.backendHost+'/file/user.jpg'
        }
    }
}
